import SearchableSelect from "../../../../components/SearchableSelect";

export default function PlatformContact() {
  return (<>
      <section className="section-space contact-section" id="contact">
        <div className="container contact-grid">
          <div className="contact-copy reveal">
            <div className="eyebrow light">{"GET STARTED"}</div>
            <h2>{"Ready to simplify how your business runs?"}</h2>
            <p>{"Start with one service today. Add everything else when you need it."}</p>
            <div className="contact-points">
              <span>{"✓ Start with one module"}</span>
              <span>{"✓ Add managed services later"}</span>
              <span>{"✓ Configure by country"}</span>
              <span>{"✓ Integrate with your existing stack"}</span>
            </div>
          </div>

          <form className="lead-form reveal delay-1" id="leadForm">
            <h3>{"Tell us what you need."}</h3>
            <div className="form-row">
              <label>{"Requirement\n                "}<SearchableSelect name="requirement" required={true}>
                  <option value="">{"Select"}</option>
                  <option>{"Software"}</option><option>{"Managed Service"}</option><option>{"Payment Integration"}</option><option>{"Customer Support"}</option><option>{"WhatsApp AI"}</option><option>{"Business Application"}</option><option>{"Something Custom"}</option>
                </SearchableSelect>
              </label>
              <label>{"Country\n                "}<input name="country" placeholder="e.g. Pakistan" required={true} />
              </label>
            </div>
            <div className="form-row">
              <label>{"Company\n                "}<input name="company" placeholder="Company name" required={true} />
              </label>
              <label>{"Company size\n                "}<SearchableSelect name="size"><option>{"1-10"}</option><option>{"11-50"}</option><option>{"51-200"}</option><option>{"201-1000"}</option><option>{"1000+"}</option></SearchableSelect>
              </label>
            </div>
            <div className="form-row">
              <label>{"Email\n                "}<input type="email" name="email" placeholder="you@company.com" required={true} />
              </label>
              <label>{"Phone\n                "}<input name="phone" placeholder="+92..." />
              </label>
            </div>
            <label>{"Requirements\n              "}<textarea name="message" rows="4" placeholder="Briefly describe what you want to achieve."></textarea>
            </label>
            <button className="btn btn-primary full" type="submit">{"Submit Request"}</button>
            <p className="form-status" id="formStatus"></p>
          </form>
        </div>
      </section>

  </>);
}
